import { GenericValidator } from '../../../../../utils/genericValidator.util';
import { OfflineOrder } from '../OfflineOrder';
import { CreateOrderValidatorRulesParams } from './offlineOrderValidator.types';

export class OfflineOrderValidator extends GenericValidator<
  OfflineOrder,
  CreateOrderValidatorRulesParams
> {}
